import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=4f1feec5"
import script from "./js/Order.js?vue&type=script&lang=js&external"
export * from "./js/Order.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports